import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {BsModalService} from 'ngx-bootstrap';
import {Router} from '@angular/router';
import {EmailLoginService} from '../services/Email-login.service';
import {IOperationResponse} from "../../shared/interfaces/IGetOperationResponse";
import {OperationResponseStatus} from "../../shared/enums/Status.enum";
import {LoaderService} from "../../shared/services/loader.service";
import {Mode} from "../../shared/form-guide/utility/enums/enums";
import {PopupNotificationComponent} from "../../shared/request/popup-notification/popup-notification.component";
import {
  InvitationLinkFailureMessageBody,
  InvitationLinkFailureMessageHeader,
  InvitationLinkSuccessMessageBody,
  InvitationLinkSuccessMessageHeader
} from "../../shared/utils/globalVariables";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-email-activation',
  templateUrl: './email-activation.component.html',
  styleUrls: ['./email-activation.component.scss']
})
export class EmailActivation implements OnInit {

  invalid:boolean = false;
  activationEmail: string = '';
  @ViewChild("activationEmailForm") loginForm:NgForm;

  constructor(private loginService:EmailLoginService, private modalService: BsModalService, private router:Router) { }

  ngOnInit() {
  }

  onActivationEmailSent(_){
    LoaderService.showLoader();
    this.loginService.SendActivationEmail(this.activationEmail)
        .subscribe((operationResponse: IOperationResponse): void => {
          LoaderService.hideLoader();
          debugger;
          if (operationResponse.Status == OperationResponseStatus.Success) {
            this.showModal(InvitationLinkSuccessMessageHeader, InvitationLinkSuccessMessageBody, Mode.Success,
                'login/email');
          } else {
            this.showModal(InvitationLinkFailureMessageHeader, InvitationLinkFailureMessageBody, Mode.Error,
                'login/email-activation');
          }
        }, (httpErrorResponse: HttpErrorResponse) => {
          LoaderService.hideLoader();
          this.showModal(InvitationLinkFailureMessageHeader, httpErrorResponse.error.Message, Mode.Error,
              'login/email-activation');
        });
  }


  private showModal(alertHeader:string, alertMassage: string, alertMode: Mode, exitNavigationURL: string) {

    const initialState = {
      alertMode,
      alertHeader,
      alertMassage,
      navigateOnExit: true,
      exitNavigationURL,
      enableNavigation: true,
      backLableText: 'Workspace',
      navigationURL: 'home',
    };

    let alertModalRef = this.modalService.show(PopupNotificationComponent, {
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
    });

    alertModalRef.content.closeBtnName = 'Close';
  }
}
